import img1 from "../../assets/Images/Event Booking/Customer-List.png"

export default function CustomerList() {
  return (
    <section id="customer-list" className="space-y-16">

      {/* SECTION TITLE */}
      <div>
        <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
          2.7 Customer List
        </h2>
        <p className="text-slate-600 max-w-3xl">
          The Customer List module provides a centralized view of all customers
          who have made bookings in EventFlow. It helps staff quickly access
          customer details, booking history, and contact information.
        </p><br />
         <p className="text-slate-600">
          Every time a booking is created, customer information is stored and
          automatically added to the Customer List. This module acts as a
          customer directory for reference, reporting, and future bookings.
        </p>
      </div>

      {/* OVERVIEW */}
      {/* <section className="bg-white border-l border-[#C9A24E] p-4">
        <h3 className="text-lg font-semibold mb-2">
          Overview
        </h3>
       
      </section> */}

      {/* NAVIGATION */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Navigation & Access
        </h3>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          {/* <li>
            Accessible from <strong>Reports → Customer List</strong>
          </li> */}
          <li>
            Displays customers across all bookings
          </li>
          <li>
            No manual customer creation is required
          </li>
        </ul>
      </section>

      {/* TABLE */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Customer List Table
        </h3>

        <p className="text-slate-600 mb-4">
          The table displays all registered customers along with their personal
          and booking-related details.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Client name</li>
          <li>Primary mobile number</li>
          <li>CNIC / identification number</li>
          <li>Residential address</li>
          <li>Total number of bookings</li>
          <li>Office or alternate contact number</li>
        </ul>

        <div className="rounded-lg p-4 mt-4">
          <img src={img1} alt="" />
        </div>
      </section>

      {/* BOOKINGS LINK */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Booking Count & History
        </h3>

        <p className="text-slate-600 mb-3">
          Each customer record shows the total number of bookings associated
          with that customer.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>
            Clicking the booking count opens related booking records
          </li>
          <li>
            Helps identify repeat and returning customers
          </li>
          <li>
            Useful for customer relationship tracking
          </li>
        </ul>
      </section>

      {/* SEARCH & FILTER */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Search & Pagination
        </h3>

        <p className="text-slate-600 mb-3">
          EventFlow provides built-in search and pagination to manage large
          customer datasets efficiently.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Search by customer name, CNIC, or phone number</li>
          <li>Configurable entries per page</li>
          <li>Fast navigation through large customer lists</li>
        </ul>
      </section>

      {/* DATA CONSISTENCY */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Data Accuracy & Consistency
        </h3>

        <p className="text-slate-600 max-w-3xl">
          Customer information is automatically pulled from booking records,
          ensuring consistency across bookings, receipts, invoices, and reports.
          Any update to customer details reflects across all related records.
        </p>
      </section>

      {/* WHY IMPORTANT */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Why the Customer List Matters
        </h3>

        <p className="text-slate-600 max-w-3xl">
          A centralized customer directory improves operational efficiency,
          supports better customer service, and helps management understand
          customer behavior and repeat booking trends.
        </p>
      </section>

    </section>
  );
}
